import View from './View';
import schema from './schema';
import icon from '@plone/volto/icons/discussion.svg';

const FAQsBlock = {
  id: 'faqs',
  title: 'FAQs',
  view: View,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default FAQsBlock;